import { render, staticRenderFns } from "./creaArticolo.vue?vue&type=template&id=b8ba3560"
import script from "./creaArticolo.vue?vue&type=script&lang=js"
export * from "./creaArticolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports